
export default {
  name: 'GridList',
  props: {
    gridData: {
      type: Array,
      default: () => []
    },
    cols: {
      type: Number,
      default: 3
    },
    showSelected: {
      type: Boolean,
      default: false
    },
    showNewMark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    setGridColSize() {
      const colSize = this.cols;
      return `col-${colSize}`;
    },
    
  },
  watch: {
    gridData: {
      handler() {
        this.selectedIdx = null;
      },
      deep: true
    }
  },
  data() {
    return {
      selectedIdx: null
    }
  },
  methods: {
    displayItem(item) {
      return typeof item === 'string' ? item : item.name;
    },
    emitItem(item,idx) {
      if(this.showSelected) {
        this.selectedIdx = idx;
      }
      this.$emit('selectItem', item);
    },
    isSelected(idx) {
      if(this.showSelected)
        return {selected: this.selectedIdx === idx}
    }
  }
}
